import React from 'react';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import PortalHeader from '../../components/Portal/PortalHeader';
import TeacherSchedule from '../../components/Portal/Work/TeacherSchedule';
import MyLessonsTaught from '../../components/Portal/Work/MyLessonsTaught';
import '../../components/Portal/portalSurface.css';

/* "My schedule" for the ADMIN shell.
 *
 * The component below is the one Annelise has had since E3b — own/full-studio
 * toggle, coverage requests, the released-run reader. It was mounted in exactly
 * one place: TeacherDashboard, which WorkShell renders only for NON-admin
 * employees. So Grace and Anthony, who are both `role:'admin'` AND both linked
 * to real `teachers` docs, had no way to see their own assignments anywhere —
 * only the studio-wide rotation board. This page closes that gap without
 * touching WorkShell's role split or TeacherSchedule itself.
 *
 * `teacherId` comes from users/{uid}.teacherId, the same mapping TeacherSchedule
 * uses under TeacherDashboard and MyAvailability uses beside it. An admin whose
 * account carries no teacherId (the `anthony+testadmin@` QA account today) is
 * handled inside TeacherSchedule, which renders "Your teaching profile isn't
 * linked yet…" rather than an empty list — an empty list would read as "you have
 * no lessons", which is a different and wrong statement.
 *
 * STYLES: the .td-* rules TeacherSchedule renders live in TeacherDashboard.css,
 * which only TeacherDashboard imports. That is a real coupling, but it is NOT a
 * bug to fix here and this page deliberately does not re-import that file:
 * CRA emits ONE global stylesheet, so those rules are in the bundle either way
 * (measured 2026-08-30 — `td-schedule__bar` is present in main.css with the
 * import removed). Adding it changed only the CSS bundle HASH, by shifting rule
 * order in the cascade — risk bought for nothing. If this app ever code-splits
 * CSS per route, that changes and the import becomes required; until then the
 * honest note is cheaper than the perturbation.
 */
function MySchedule() {
	const { userProfile } = useAuth();

	return (
		<>
			<PortalHeader
				title='My Schedule'
				subtitle='Your assigned days from the latest released run — switch to Full studio for everyone'
			/>
			<div className='ps-page'>
				<MyLessonsTaught teacherId={userProfile?.teacherId} />
				<TeacherSchedule teacherId={userProfile?.teacherId} />
			</div>
		</>
	);
}

export default MySchedule;
